import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import {
  setHelloMessagePopupBeenDismissed,
  setProvisionPopupBeenDismissed,
  setIsBarryIconVisible,
  setIsBarryDialogOpen,
  openProvisionPopup,
} from 'store/barry/barry'

export type BarryView = {
  isBarryDialogOpen: boolean
  isBarryIconVisible: boolean
  setBarryDialogOpen: (open: boolean) => void
  setBarryIconVisibility: (open: boolean) => void
  dismissHelloPopupMessage: () => void
  dismissProvisioningHelpPopup: () => void
  setBarryProvisioningHelpPopupOpen: (open: boolean) => void
}

/*Common controller for both static pages and dashboard*/
export default function useBarryViewState(): BarryView {
  const dispatch = useAppDispatch()
  const { isBarryDialogOpen, isBarryIconVisible } = useAppSelector(s => s.barry.userExperience)

  const setBarryDialogOpen = useCallback(
    (open: boolean) => {
      dispatch(setIsBarryDialogOpen(open))
    },
    [dispatch],
  )

  const setBarryIconVisibility = useCallback(
    (open: boolean) => {
      dispatch(setIsBarryIconVisible(open))
    },
    [dispatch],
  )

  const dismissHelloPopupMessage = useCallback(() => {
    dispatch(setHelloMessagePopupBeenDismissed(Date.now()))
  }, [dispatch])

  const dismissProvisioningHelpPopup = useCallback(() => {
    dispatch(setProvisionPopupBeenDismissed(Date.now()))
  }, [dispatch])

  const setBarryProvisioningHelpPopupOpen = useCallback(
    (open: boolean) => {
      dispatch(openProvisionPopup(open))
    },
    [dispatch],
  )

  return {
    isBarryDialogOpen: !!isBarryDialogOpen,
    isBarryIconVisible: !!isBarryIconVisible,
    setBarryDialogOpen,
    setBarryIconVisibility,
    dismissHelloPopupMessage,
    dismissProvisioningHelpPopup,
    setBarryProvisioningHelpPopupOpen,
  }
}
